export default "__VITE_ASSET__DXBQlD42__"